import { Route, Routes } from "react-router-dom";
import InternationalWireForm from "./InternationalWireForm";
import InternationalWireReview from "./InternationalWireReview";
import { SudoProvider, SudoRoutes } from "../../../SudoContext";
import RequestOTP from "../../../SudoContext/RequestOTP";
import SubmitOTP from "../../../SudoContext/SubmitOTP";
import ReceiptScreen from "./ReceiptScreen";

const InternationalWireContainer = () => (
  <SudoProvider basename="wires/international">
    <Routes>
      <Route path="review" element={<InternationalWireReview />} />
      <Route path={`${SudoRoutes.RequestOTP}`} element={<RequestOTP />} />
      <Route path={`${SudoRoutes.SubmitOTP}`} element={<SubmitOTP />} />
      <Route path="receipt" element={<ReceiptScreen />} />
      <Route path="/" element={<InternationalWireForm />} />
    </Routes>
  </SudoProvider>
);

export default InternationalWireContainer;
